<div class="activity-types">
  @if (loading) {
    <app-loader></app-loader>
  }
  <list-view [headers]="activityTypesHeader" [sorting]="sorting" (onSortChange)="onSortChange($event)">
    @for (activity of activitiesList?.interactiveActivityTypes; track activity) {
      <div class="row">
        <div>{{ activity.title }}</div>
        <div>{{ activity.createdAt }}</div>
        <div>
          <div class="copy-field">
            <app-textfield [readonly]="true" [value]="activity.interactiveTypeUrl" size="tiny"> </app-textfield>
            <copy-to-clipboard [value]="activity.interactiveTypeUrl">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9 13V12C9 10.346 10.346 9 12 9H13V5.667C13 5.299 12.701 5 12.333 5H5.667C5.299 5 5 5.299 5 5.667V12.333C5 12.701 5.299 13 5.667 13H9ZM9 15H5.667C4.196 15 3 13.804 3 12.333V5.667C3 4.196 4.196 3 5.667 3H12.333C13.804 3 15 4.196 15 5.667V9H18C19.654 9 21 10.346 21 12V18C21 19.654 19.654 21 18 21H12C10.346 21 9 19.654 9 18V15ZM11 12C11 11.449 11.449 11 12 11H18C18.552 11 19 11.449 19 12V18C19 18.551 18.552 19 18 19H12C11.449 19 11 18.551 11 18V12Z"
                />
              </svg>
            </copy-to-clipboard>
          </div>
        </div>
        <div data-cy="ia-type-is-custom-html">{{ activity.isCustomHtml ? 'Yes' : 'No' }}</div>
        <div class="list-actions">
          @if (canManageIaTypes) {
            <a
              routerLink="/interactive-activity-type/{{ activity.interactiveActivityTypeId }}"
              title="Edit Interactive Activity Type"
              data-cy="edit-ia-type-btn"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.0187 10.6787L13.3237 7.98367L15.2717 6.03467L17.9657 8.72867L16.0187 10.6787ZM9.07965 17.6247L6.10265 17.8957L6.36665 14.9397L11.9837 9.32267L14.6797 12.0187L9.07965 17.6247ZM19.4037 7.33767L19.4027 7.33667L16.6647 4.59867C15.9237 3.85967 14.6507 3.82467 13.9487 4.52967L4.95265 13.5257C4.62665 13.8507 4.42465 14.2827 4.38265 14.7397L4.00365 18.9097C3.97765 19.2047 4.08265 19.4967 4.29265 19.7067C4.48165 19.8957 4.73665 19.9997 4.99965 19.9997C5.03065 19.9997 5.06065 19.9987 5.09065 19.9957L9.26065 19.6167C9.71865 19.5747 10.1497 19.3737 10.4747 19.0487L19.4717 10.0517C20.1997 9.32167 20.1687 8.10367 19.4037 7.33767Z"
                />
              </svg>
            </a>
          } @else {
            <a
              routerLink="/interactive-activity-type/{{ activity.interactiveActivityTypeId }}"
              title="View Interactive Activity Type"
              data-cy="view-ia-type-btn"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path
                  d="M21.87 11.5c-.64-1.11-4.16-6.68-10.14-6.5-5.53.14-8.73 5-9.6 6.5a1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 0 0 0-1zM12.22 17c-4.31.1-7.12-3.59-8-5 1-1.61 3.61-4.9 7.61-5 4.29-.11 7.11 3.59 8 5-1.03 1.61-3.61 4.9-7.61 5z"
                />
                <path d="M12 8.5a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 12 8.5zm0 5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z" />
              </svg>
            </a>
          }
        </div>
      </div>
    }
  </list-view>
</div>
